var VariableType;
(function (VariableType) {
    VariableType["String"] = "string";
    VariableType["Number"] = "number";
    VariableType["Integer"] = "integer";
    VariableType["Boolean"] = "boolean";
    VariableType["Object"] = "object";
    VariableType["Array"] = "array";
    VariableType["Date"] = "date";
    VariableType["DateTime"] = "datetime";
})(VariableType || (VariableType = {}));
var VariableGroupKey;
(function (VariableGroupKey) {
    VariableGroupKey["Meta"] = "meta";
    VariableGroupKey["Fields"] = "fields";
    VariableGroupKey["Iteration"] = "iteration";
})(VariableGroupKey || (VariableGroupKey = {}));
export { VariableType, VariableGroupKey, };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJmYWNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi93b3JrZmxvdy9pbnRlcmZhY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBSyxZQVNKO0FBVEQsV0FBSyxZQUFZO0lBQ2YsaUNBQWlCLENBQUE7SUFDakIsaUNBQWlCLENBQUE7SUFDakIsbUNBQW1CLENBQUE7SUFDbkIsbUNBQW1CLENBQUE7SUFDbkIsaUNBQWlCLENBQUE7SUFDakIsK0JBQWUsQ0FBQTtJQUNmLDZCQUFhLENBQUE7SUFDYixxQ0FBcUIsQ0FBQTtBQUN2QixDQUFDLEVBVEksWUFBWSxLQUFaLFlBQVksUUFTaEI7QUFFRCxJQUFLLGdCQUlKO0FBSkQsV0FBSyxnQkFBZ0I7SUFDbkIsaUNBQWEsQ0FBQTtJQUNiLHFDQUFpQixDQUFBO0lBQ2pCLDJDQUF1QixDQUFBO0FBQ3pCLENBQUMsRUFKSSxnQkFBZ0IsS0FBaEIsZ0JBQWdCLFFBSXBCO0FBd05ELE9BQU8sRUFDTCxZQUFZLEVBQ1osZ0JBQWdCLEdBVWpCLENBQUMifQ==